import { render } from "./vehiculos.vue?vue&type=template&id=4b14da38&scoped=true"
import script from "./vehiculos.vue?vue&type=script&lang=js"
export * from "./vehiculos.vue?vue&type=script&lang=js"

import "./vehiculos.vue?vue&type=style&index=0&id=4b14da38&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b14da38"]])

export default __exports__